<template>
  <div>
    <SectionThreeItemsHeader class="mb-6">
      <template v-slot:item-center>
        <h2>Contact Details</h2>
      </template>
      <template v-slot:item-right>
        <EditContactDetailsAction />
      </template>
    </SectionThreeItemsHeader>
    <Permissioned section="workers.edit" vertical>
      <LabeledText label="Address" :permission="permissions.address">
        {{ address || "-" }}
      </LabeledText>
      <LabeledText label="Phone Number" :permission="permissions.phoneNumber">
        {{ userData.phone }}
      </LabeledText>
    </Permissioned>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import Permissioned from "@/components/common/Permissioned";
import SectionThreeItemsHeader from "@/components/common/SectionThreeItemsHeader/SectionThreeItemsHeader";
import LabeledText from "@/components/common/BaseDetails/LabeledText";
import EditContactDetailsAction from "@/views/settings/components/actions/EditContactDetailsAction";
import { PERMISSIONS } from "@/constants/workers";
import { formatAddress } from "@/utils/users";
import { FETCH_COUNTRIES } from "@/store/modules/data/actions";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { isEmpty } from "lodash";

const { mapState } = createNamespacedHelpers(AUTH_NAMESPACE);
const { mapState: dataMapState, mapActions } = createNamespacedHelpers(
  DATA_NAMESPACE
);

export default {
  components: {
    LabeledText,
    Permissioned,
    EditContactDetailsAction,
    SectionThreeItemsHeader
  },
  async created() {
    if (isEmpty(this.countries)) {
      await this.fetchCountries();
    }
  },
  data() {
    return {
      permissions: PERMISSIONS.CONTACT_DETAILS
    };
  },
  computed: {
    ...mapState({
      userData: state => state.userData
    }),
    ...dataMapState({
      countries: state => state.countries
    }),
    address() {
      return formatAddress(this.userData.addresses, this.countries);
    }
  },
  methods: {
    ...mapActions({
      fetchCountries: FETCH_COUNTRIES
    })
  }
};
</script>

<style lang="scss"></style>
